var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMabSummaryCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.831 17.6663C10.9637 18.156 10.2623 18.8935 9.81693 19.7843C9.37152 20.6752 9.2023 21.6787 9.33097 22.6663C10.3186 22.795 11.3222 22.6258 12.213 22.1804C13.1038 21.735 13.8413 21.0336 14.331 20.1663M9.33097 16.833C10.8169 17.0096 12.2002 17.681 13.2583 18.739C14.3164 19.7971 14.9877 21.1804 15.1643 22.6663C15.9009 22.2417 16.517 21.6362 16.9545 20.9071C17.3919 20.178 17.6362 19.3495 17.6643 18.4997C19.0636 18.0074 20.2854 17.1113 21.1754 15.9247C22.0654 14.738 22.5835 13.3141 22.6643 11.833C22.6643 11.17 22.4009 10.5341 21.9321 10.0652C21.4632 9.5964 20.8273 9.33301 20.1643 9.33301C18.6832 9.41376 17.2593 9.9319 16.0726 10.8219C14.886 11.7119 13.9899 12.9337 13.4976 14.333C12.6479 14.3611 11.8193 14.6054 11.0902 15.0428C10.3611 15.4803 9.75563 16.0964 9.33097 16.833ZM17.6643 13.4997C17.6643 13.7207 17.7521 13.9326 17.9084 14.0889C18.0647 14.2452 18.2766 14.333 18.4976 14.333C18.7187 14.333 18.9306 14.2452 19.0869 14.0889C19.2432 13.9326 19.331 13.7207 19.331 13.4997C19.331 13.2787 19.2432 13.0667 19.0869 12.9104C18.9306 12.7541 18.7187 12.6663 18.4976 12.6663C18.2766 12.6663 18.0647 12.7541 17.9084 12.9104C17.7521 13.0667 17.6643 13.2787 17.6643 13.4997Z",
    stroke: "url(#paint0_linear_2128_4211)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2128_4211",
    x1: 22.6643,
    y1: 19.9646,
    x2: 8.90997,
    y2: 19.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58F2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMabSummaryCreate);
export default __webpack_public_path__ + "static/media/mab-summary-create.3007fd2d6a4ed7a7cec7afd6c8c3b9a8.svg";
export { ForwardRef as ReactComponent };